
  import { LoginUserCommand } from '@/apiclient/apiclient_generated';
  import { AccountModule, AccountStore } from '@/store/account';
  import Routes from '@/types/Routes';
  import { Options, Vue } from 'vue-class-component';
  import { Prop } from 'vue-property-decorator';

  @Options({})
  export default class Login extends Vue {
    @Prop() loggedInCallBack;

    private accountStore: AccountModule = AccountStore;

    email = '';
    password = '';
    showFormError = false;

    isLoading = false;

    created() {
      this.resetCredentials();
    }

    private resetCredentials() {
      this.email = '';
      this.password = '';
    }

    get isFormValid() {
      return this.email && this.password;
    }

    async login() {
      this.showFormError = !this.email || !this.password;
      if (!this.isFormValid) {
        return;
      }

      this.isLoading = true;

      const command = {
        email: this.email,
        password: this.password
      } as LoginUserCommand;

      const success = await this.accountStore.login(command).finally(() => (this.isLoading = false));

      if (success) {
        this.loggedInCallBack();

        this.resetCredentials();
      }
    }

    register() {
      this.$router.push(Routes.register.path);
    }

    resetPassword() {
      this.$router.push(Routes.resetPassword.path);
    }
  }
